import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { cn } from "@/shared/lib/utils";

interface AuthSubmitButtonProps {
  loading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  htmlType?: "submit" | "button";
  className?: string;
}

export function AuthSubmitButton({
  loading = false,
  disabled = false,
  children,
  onClick,
  htmlType = "submit",
  className,
}: AuthSubmitButtonProps) {
  return (
    <Button
      htmlType={htmlType}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
      block
      className={cn(
        "!h-auto !rounded-xl !border-none !py-3 !text-sm !font-semibold !text-white !transition-all !duration-200 !ease-out hover:!opacity-80",
        className,
      )}
      style={{ backgroundColor: "rgba(228, 0, 43, 0.5)" }}
    >
      <span className="relative inline-flex items-center">
        {loading && (
          <LoadingOutlined
            spin
            aria-hidden="true"
            className="absolute end-full me-1.5 text-sm"
          />
        )}
        {children}
      </span>
    </Button>
  );
}
